<template>
  <div>
    <!--   {{ parametriGlobali }}
     {{ $store.getters.riepilogoGenerale }}{{ parametriGlobali }}
    
      {{ $store.state.anagrafica }}
    
rinnovi}}-->
    <v-content>
      <div class="elegant-frame">
        <v-container fluid>
          <span class="h3 ma-1 font-bold font-italic float-left">
            <!--{{ $t("nomeUni") }}-->
          </span>
          <!--<v-system-bar
        class="font-weight-bold"
        lights-out
  height="30"
><h5 class="font-weight-bold">{{ $t("testoLogo") }}</h5></v-system-bar>-->

          <div>
            <!--<v-btn
              color="primary"
              elevation="15"
              fab
              large
              class="float-right pa-1"
              @click="logout"
              ><div class="text-h4 font-weight-bold text-white">
                <i class="material-icons">logout</i>
              </div>
            </v-btn>
            <v-btn
              color="primary"
              elevation="15"
              fab
              large
              class="float-right"
              @click="lingua('it')"
              ><div class="text-h6 font-weight-bold text-white">ITA</div>
            </v-btn>
          

          <v-btn
            color="primary"
            elevation="15"
            fab
            large
            class="float-right pa-3"
            @click="lingua('en')"
            ><div class="text-h6 font-weight-bold text-white">ENG</div>
          </v-btn>
          <v-tooltip top color="blue-grey darken-4">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="mostraGuida"
                color="primary"
                elevation="15"
                fab
                large
                class="float-right pa-3"
                ><div class="text-h4 font-weight-bold text-white">
                  <i class="material-icons">info</i>
                </div>
              </v-btn></template
            ><b
              ><strong>{{ $t("istruzioni.tasto") }}</strong></b
            ></v-tooltip
          >-->

            <div class="modern-header-wrapper">
              <v-card class="modern-header-card" elevation="12">
                <!-- Action Buttons Row -->
                <v-row class="ma-0 header-actions-row">
                  <v-col cols="12" class="d-flex justify-end align-center pa-3">
                    <div class="action-buttons-group">
                      <!-- Language Buttons -->
                      <v-btn
                        color="#c8a501"
                        elevation="4"
                        small
                        class="action-btn mx-1"
                        @click="lingua('it')"
                      >
                        <span class="font-weight-bold">ITA</span>
                      </v-btn>

                      <v-btn
                        color="#c8a501"
                        elevation="4"
                        small
                        class="action-btn mx-1"
                        @click="lingua('en')"
                      >
                        <span class="font-weight-bold">ENG</span>
                      </v-btn>

                      <v-btn
                        color="#c8a501"
                        elevation="4"
                        small
                        class="action-btn mx-1"
                        @click="lingua('es')"
                      >
                        <span class="font-weight-bold">ESP</span>
                      </v-btn>

                      <!-- Info Button -->
                      <v-tooltip bottom color="#c8a501">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            @click="mostraGuida"
                            color="#c8a501"
                            elevation="4"
                            icon
                            class="action-btn-icon mx-1"
                          >
                            <v-icon>mdi-information</v-icon>
                          </v-btn>
                        </template>
                        <span class="font-weight-bold">{{ $t("istruzioni.tasto") }}</span>
                      </v-tooltip>

                      <!-- Logout Button -->
                      <v-btn
                        color="#d32f2f"
                        elevation="4"
                        icon
                        class="action-btn-icon action-btn-logout mx-1"
                        @click="logout"
                      >
                        <v-icon>mdi-logout</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-divider></v-divider>

                <!-- Main Content Row -->
                <v-row class="ma-0" align="center">
                  <!-- Logo Section -->
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                    class="d-flex align-center justify-center pa-4"
                  >
                    <div class="logo-container">
                      <v-img
                        src="@/assets/logoAUGv.png"
                        max-height="140"
                        max-width="140"
                        contain
                        class="logo-img"
                      ></v-img>
                    </div>
                  </v-col>

                  <!-- Title Section -->
                  <v-col
                    cols="12"
                    md="5"
                    lg="6"
                    class="pa-4"
                  >
                    <div class="title-section">
                      <h1 class="header-title">
                        {{
                          $t("presentazione", {
                            annoaccaS: parametriGlobali.annoaccademico - 1,
                            annoaccaF: parametriGlobali.annoaccademico,
                          })
                        }}
                      </h1>

                      <div class="mt-3 d-flex flex-wrap align-center gap-2">
                        <v-chip
                          v-if="parametriGlobali.semestre == 2"
                          color="#c8a501"
                          text-color="black"
                          class="animate__animated animate__fadeInLeft font-weight-bold chip-modern"
                        >
                          <v-icon left small>mdi-calendar-clock</v-icon>
                          2° {{ $t("semestre") }}
                        </v-chip>

                        <v-chip
                          v-if="parametriGlobali.operatore"
                          color="#c8a501"
                          text-color="black"
                          class="font-weight-bold chip-modern"
                        >
                          <v-icon left small>mdi-account-tie</v-icon>
                          Operatore: {{ parametriGlobali.operatore }}
                        </v-chip>
                      </div>
                    </div>
                  </v-col>

                  <!-- User Info Section -->
                  <v-col
                    cols="12"
                    md="4"
                    lg="4"
                    class="pa-4"
                  >
                    <v-card
                      class="user-info-card"
                      elevation="0"
                      outlined
                    >
                      <v-card-text class="pa-4">
                        <div class="info-item mb-3">
                          <div class="info-label">
                            <v-icon small color="#c8a501" class="mr-2">mdi-identifier</v-icon>
                            <span class="text-caption text-uppercase font-weight-bold">Prematricola</span>
                          </div>
                          <div class="info-value mt-1">
                            {{ parametriGlobali.prematricola }}
                          </div>
                        </div>

                        <v-divider class="my-3"></v-divider>

                        <div class="info-item">
                          <div class="info-label">
                            <v-icon small color="#c8a501" class="mr-2">mdi-email</v-icon>
                            <span class="text-caption text-uppercase font-weight-bold">E-mail</span>
                          </div>
                          <div class="info-value mt-1 text-truncate">
                            {{ parametriGlobali.email }}
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <!--<v-system-bar
      dark
      color="primary"
      class="ml-2 mr-2"
    >
    <span class="darken-2 white--text">N° Prematricola: <span class="font-weight-black">123445</span></span>
    
      <v-spacer></v-spacer>
      
      <v-icon class="darken-2 white--text">mdi-email</v-icon>
      <span class="darken-2 white--text">E-mail : <span class="darken-2 white--text font-weight-black">g.digiorgio@mclink.it</span></span>
    </v-system-bar>-->

            <div class="row">
              <div
                class="col-lg-4 col-md-6 col-sm-12"
                v-for="data in steps"
                :key="data.id"
              >
                <div
                  class="
                  card card-nav-tabs
                  animate__animated animate__bounceInDown
                "
                >
                  <h4
                    class="
                    card-header card-header-primary
                    font-weight-bold
                    primary
                    black--text
                    text--lighten-1
                    titolocard
                  "
                  >
                    <i class="material-icons ma-1 float-right">{{
                      data.icona
                    }}</i>
                    <v-avatar color="white" size="30" class="ma-1">
                      <span class="black--text text-h6">{{ data.id }}</span>
                    </v-avatar>

                    {{ data.titolo[$i18n.locale] }}

                    <!--<span v-if="data.id=='1'" class="animate__animated animate__bounceInLeft float right"><i v-if="data.id=='1'" class="material-icons">task_alt</i></span>-->

                    <div
                      v-if="StatoStep[data.id - 1].completato"
                      class="animate__animated animate__bounceInLeft float-right"
                    >
                      <span class="badge badge-secondary">
                        {{ $t("cardCompleta") }}</span
                      >
                    </div>
                  </h4>

                  <div class="card-body">
                    <h4 class="card-title">
                      {{ data.testo[$i18n.locale] }}
                    </h4>

                    <div class="text-right">
                      <!--btn apri form-->
                      <v-badge
                        bordered
                        color="error"
                        icon="mdi-lock"
                        overlap
                        :value="
                          (data.id == 5 || data.id == 6) &&
                            !(
                              StatoStep[1].completato && StatoStep[2].completato
                            )
                        "
                      >
                        <v-btn
                          color="#c8a501"
                          large
                          elevation="6"
                          class="white--text schede btn-card-action"
                          :class="{
                            'disable-events':
                              (data.id == 5 || data.id == 6) &&
                              !(
                                StatoStep[1].completato &&
                                StatoStep[2].completato
                              ),
                          }"
                          @click="apriForm(data.componente)"
                        >
                          <i
                            class="material-icons mr-2"
                            v-show="StatoStep[data.id - 1].completato == true"
                            >edit</i
                          >
                          {{
                            $store.state.StatoStep[data.id - 1].completato ==
                            false
                              ? $t("tastoStep.compila")
                              : $t("tastoStep.modifica")
                          }}
                        </v-btn>
                      </v-badge>
                      <!--fine btn-->

                      <!--<button
                  class="btn btn-action darken-2"
                  :disabled="(data.id==5 || data.id==6) && !$store.state.StatoStep[4].completato"
                  @click="apriForm(data.componente)"
                  
                >  
                <i class="material-icons" v-show="$store.state.StatoStep[data.id].completato== true">edit</i>
                  {{ $store.state.StatoStep[data.id].completato== false  ? $t("tastoStep.compila"): $t("tastoStep.modifica") }}
                
                </button>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <keep-alive>
            <component :is="componenteAttivo" :attivo="true"></component>
          </keep-alive>
        </v-container>
      </div>
    </v-content>
    <v-footer app bottom fixed padless>
      <v-card
        class="flex bg-light border d-flex align-center px-4 py-3"
        flat
        tile
      >
        <div class="d-flex align-center">
          <v-btn
            id="btnSalva"
            @click="salvaDati"
            v-bind="attrs"
            v-on="on"
            color="#c8a501"
            large
            elevation="8"
            class="white--text btn-theme mr-2"
          >
            <v-icon left>mdi-content-save</v-icon>
            {{ $t("salva") }}
          </v-btn>
          <v-icon
            class="ml-1"
            v-tooltip="$t('salvaDati.info')"
            large
            color="#c8a501"
          >
            mdi-help-circle-outline
          </v-icon>
        </div>

        <v-spacer></v-spacer>

        <div class="d-flex align-center">
          <p
            id="btnInvia"
            v-if="!checkStepCompletati"
            class="ma-0 mr-3 font-weight-black h5 d-flex align-center"
          >
            {{ $t("stepCompilati_1") }}
            <v-avatar color="success" size="30" class="mx-2">
              <span class="white--text text-h6">{{ StepCompletati }}</span>
            </v-avatar>
            {{ $t("stepCompilati_2", { step: StatoStep.length }) }}
          </p>

          <p
            v-if="checkStepCompletati"
            class="ma-0 mr-3 font-weight-black h5 d-flex align-center animate__animated animate__flash"
          >
            <v-icon large color="success" class="mr-2"> check_circle </v-icon>
            {{ $t("stepCompletati") }}
          </p>

          <v-btn
            v-if="checkStepCompletati"
            @click="invioScheda"
            color="#2e7d32"
            large
            elevation="8"
            class="animate__animated animate__pulse animate__infinite infinite font-weight-bold btn-invia white--text"
          >
            <v-icon left>mdi-send</v-icon>
            {{ $t("invioRichiesta.btnInvio") }}
          </v-btn>
        </div>
      </v-card>
    </v-footer>

    <!-- guida -->

    <v-tour name="myTour" :steps="stepsTour" :options="tourOpzioni"></v-tour>
    <!-- fine guida -->
  </div>
</template>

<script>
import introduzione from "@/components/introduzione";
import anagrafica from "@/components/anagrafica";
import documenti from "@/components/documenti";
import indirizzi from "@/components/indirizzi";
import iscrizione from "@/components/iscrizione";
import corsi from "@/components/corsi";
import riepilogo from "@/components/riepilogo";
import studiprevi from "@/components/studiprevi";

export default {
  name: "Home",

  data() {
    return {
      componenteAttivo: "",
      linguaAttiva: this.$i18n.locale,
      componentKey: 0,
    };
  },
  components: {
    introduzione,
    anagrafica,
    documenti,
    indirizzi,
    studiprevi,
    iscrizione,
    corsi,
    riepilogo,
  },

  watch: {},

  computed: {
    tourOpzioni() {
      return {
        highlight: true,
        labels: {
          buttonSkip: this.$t("istruzioni.esci"),
          buttonPrevious: this.$t("istruzioni.indietro"),
          buttonNext: this.$t("istruzioni.avanti"),
          buttonStop: this.$t("istruzioni.fine"),
        },
      };
    },

    stepsTour() {
      return [
        {
          target: ".schede", // We're using document.querySelector() under the hood
          content: this.$t("istruzioni.step1"),
        },
        {
          target: "#btnSalva",
          content: this.$t("istruzioni.step2"),
        },
        {
          target: "#btnInvia",
          content: this.$t("istruzioni.step3"),
          params: {
            placement: "top",
          },
        },
      ];
    },
    steps() {
      return this.$store.state.stepiscrizione;
    },
    parametriGlobali() {
      return this.$store.state.parametri;
    },

    StepCompletati() {
      return this.$store.getters.getStatoSteps;
    },
    StatoStep() {
      return this.$store.state.StatoStep;
    },
    checkStepCompletati() {
      let risultato = false;
      if (this.StepCompletati == this.StatoStep.length) {
        risultato = true;
      }
      return risultato;
    },
  },

  methods: {
    mostraGuida() {
      this.$tours["myTour"].start();
    },

    salvaDati() {
      this.$swal
        .fire({
          confirmButtonClass: "primary",
          cancelButtonClass: "primary",
          title: this.$t("salvaDati.domanda"),
          text: this.$t("salvaDati.nota"),
          icon: "info",
          showCancelButton: true,
          confirmButtonText: this.$t("salvaDati.btnConferma"),
          cancelButtonText: this.$t("salvaDati.btnAnnulla"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            //salvo i dati
            this.parametriGlobali.flagConfermaInvio = false; // sto solo salvando i dati, non sono pronto per l'invio
            this.$store
              .dispatch("salvaDatiDBEvent", { flagConferma: false })
              .then((r) => {
                if (r == "OK") {
                  this.$swal.fire({
                    title: this.$t("salvaDati.fine.titolo"),
                    text: this.$t("salvaDati.fine.testo"),
                    //text: JSON.stringify(this.$store.getters.riepilogoGenerale),
                    icon: "success",
                    confirmButtonText: "OK",
                  });
                } else {
                  this.$swal.fire({
                    confirmButtonClass: "primary",
                    cancelButtonClass: "primary",
                    title: this.$t("errore"),
                    //text: this.$t("salvaDati.fine.testo"),
                    //text: JSON.stringify(this.$store.getters.riepilogoGenerale),
                    icon: "error",
                    confirmButtonText: "OK",
                  });
                }
              });
          }
        });
    },
    invioScheda() {
      if (!this.checkStepCompletati) {
        this.$swal({
          title: "Attenzione!",
          icon: "error",
          text:
            "Per poter inviare la tua richiesta di immatricolazione deve completare tutte le schede!",
          type: "error",
          buttonsStyling: false,
          confirmButtonClass: "primary",
        });
      } else {
        // richiesta conferma invio dati
        this.$swal
          .fire({
            confirmButtonClass: "primary",
            cancelButtonClass: "primary",
            title: this.$t("invioRichiesta.domanda"),
            text: this.$t("invioRichiesta.nota"),
            icon: "question",
            showCancelButton: true,
            confirmButtonText: this.$t("invioRichiesta.btnConferma"),
            cancelButtonText: this.$t("invioRichiesta.btnAnnulla"),
          })
          .then((result) => {
            if (result.isConfirmed) {
              //
              //salvo i dati,metto lo stato in presentata, ed invio la mail
              this.parametriGlobali.flagConfermaInvio = true;

              this.$store.dispatch("salvaDatiDBEvent").then((r) => {
                if (r == "OK") {
                  this.$swal
                    .fire({
                      confirmButtonClass: "primary",
                      cancelButtonClass: "primary",
                      title: this.$t("invioRichiesta.fine.titolo"),
                      text: this.$t("invioRichiesta.fine.testo"),
                      icon: "success",
                      confirmButtonText: "OK",
                    })
                    .then(() => {
                      this.$router.push("/");
                    });
                } else {
                  this.$swal.fire({
                    confirmButtonClass: "primary",
                    cancelButtonClass: "primary",
                    title: this.$t("errore"),
                    //text: this.$t("salvaDati.fine.testo"),
                    //text: JSON.stringify(
                    //  this.$store.getters.riepilogoGenerale
                    //),
                    icon: "error",
                    confirmButtonText: "OK",
                  });
                }
              });
              //
            }
          });
        //

        //this.componenteAttivo = "";
        //this.componenteAttivo = "riepilogo";
      }
    },

    forceRerender() {
      this.componentKey += 1;
    },
    lingua(flag) {
      this.componenteAttivo = "";
      this.$i18n.locale = flag;
    },

    testo_card(dati) {
      return dati.text_ && this.$i18n.locale;
    },

    apriForm(tipoForm) {
      this.componenteAttivo = "";
      this.componenteAttivo = tipoForm;
    },
    logout() {
      this.$swal
        .fire({
          confirmButtonClass: "primary",
          cancelButtonClass: "primary",
          title: this.$t("logOut.domanda"),
          html: this.$t("logOut.nota"),
          icon: "question",
          showCancelButton: true,
          confirmButtonText: this.$t("invioRichiesta.btnConferma"),
          cancelButtonText: this.$t("invioRichiesta.btnAnnulla"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            var isOperatore = this.parametriGlobali.operatore;
            this.$store.commit("resetSessione");
            if (isOperatore) {
              this.$router.push("/segreteria");
            } else {
              this.$router.push("/");
            }
          }
        });
    },
  },
  mounted: function() {
    if (this.parametriGlobali.token == null) {
      this.$router.push("/");
    }
    if (this.parametriGlobali.statoDomanda == "PRESENTATA") {
      this.$swal.fire({
        toast: true,

        confirmButtonClass: "primary",
        cancelButtonClass: "primary",
        title: this.$t("corsi.attenzione"),
        html: this.$t("login.statoPresentata"),
        //text: JSON.stringify(this.$store.getters.riepilogoGenerale),
        icon: "warning",
        confirmButtonText: "OK",
      });
    }

    //this.$isLoading(true);
    //setTimeout(() => this.$isLoading(false), 2000);
    //this.$store.dispatch('restoreDatiEvent')
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap");

/*button,
[type="button"],
[type="reset"],
[type="submit"],
[role="button"] {
  cursor: pointer;
  color: white;
}

.badge-pug {
  background-color: #ff9800;
  color: white;
  font-size: initial;
  text-transform: capitalize;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}
.list-enter-active,
.list-leave-active {
  transition: opacity 0.5s ease;
}*/

/* Sfondo grigio chiaro sfumato */
.v-content {
  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 50%, #f5f5f5 100%);
  min-height: 100vh;
}

/* Animazione comparsa casuale */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Applica animazione ai bottoni header */
.btn-logout,
.btn-theme {
  animation: fadeInUp 0.6s ease-out backwards;
}

.btn-logout {
  animation-delay: 0.1s;
}

.btn-theme:nth-of-type(1) {
  animation-delay: 0.2s;
}

.btn-theme:nth-of-type(2) {
  animation-delay: 0.3s;
}

.btn-theme:nth-of-type(3) {
  animation-delay: 0.4s;
}

.btn-theme:nth-of-type(4) {
  animation-delay: 0.5s;
}

/* Animazione per il jumbotron */
.jumbotron {
  animation: fadeInUp 0.8s ease-out 0.3s backwards;
}

/* Animazione per le card - ritardi casuali */
.card-nav-tabs:nth-child(1) {
  animation: fadeInUp 0.7s ease-out 0.6s backwards;
}

.card-nav-tabs:nth-child(2) {
  animation: fadeInUp 0.7s ease-out 0.8s backwards;
}

.card-nav-tabs:nth-child(3) {
  animation: fadeInUp 0.7s ease-out 0.4s backwards;
}

.card-nav-tabs:nth-child(4) {
  animation: fadeInUp 0.7s ease-out 1s backwards;
}

.card-nav-tabs:nth-child(5) {
  animation: fadeInUp 0.7s ease-out 0.7s backwards;
}

.card-nav-tabs:nth-child(6) {
  animation: fadeInUp 0.7s ease-out 0.9s backwards;
}

/* Animazione per il footer */
.v-footer {
  animation: fadeInUp 0.8s ease-out 1.2s backwards;
}

/* Font moderno per testo presentazione */
.testo-presentazione {
  font-family: "Poppins", "Segoe UI", "Roboto", -apple-system,
    BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 1.3;
}

.btn-action,
.btn-action:hover,
.btn-action:active,
.btn-action:visited {
  background-color: #1976d2 !important;
  float: right;
}

i.icon-yellow {
  color: #4caf50;
}

.testopiccolo {
  font-size: 13px;
}

.titolocard {
  font-size: 20px;
}

.animaBottone-enabled {
  animation: bounce-in 1.5s;
}

.disable-events {
  pointer-events: none;
  opacity: 0.6;
}

.primaryG {
  background: linear-gradient(
    135deg,
    #b7950b 0%,
    #c8a501 20%,
    #d4af37 50%,
    #f1c40f 80%,
    #fff8dc 100%
  );
}

.badgeGG {
  text-transform: none;
}
.card-header-primary {
  background: #c8a501 !important;
}

.elegant-frame {
  margin: 20px;
  padding: 25px;
  border: 3px solid transparent;
  border-image: linear-gradient(
      135deg,
      #c8a501 0%,
      #d4af37 25%,
      #f1c40f 75%,
      #c8a501 100%
    )
    1;
  border-radius: 15px;
  box-shadow: 0 8px 32px rgba(200, 165, 1, 0.15),
    0 0 0 1px rgba(200, 165, 1, 0.3);
  position: relative;
}

@media (max-width: 768px) {
  .elegant-frame {
    margin: 10px 5px;
    padding: 15px 10px;
    border-width: 2px;
    border-radius: 10px;
    box-shadow: 0 4px 16px rgba(200, 165, 1, 0.15),
      0 0 0 1px rgba(200, 165, 1, 0.3);
  }

  .float-left,
  .float-right {
    float: none !important;
    display: block;
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }

  .v-btn.float-left,
  .v-btn.float-right {
    width: 100%;
    margin: 5px 0;
  }
}

.elegant-frame::before {
  content: "";
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  background: linear-gradient(135deg, #c8a501, #d4af37, #f1c40f, #c8a501);
  border-radius: 18px;
  z-index: -1;
}

/* Stili migliorati per i bottoni */
.btn-logout {
  box-shadow: 0 4px 12px rgba(211, 47, 47, 0.4) !important;
  transition: all 0.3s ease;
  font-weight: bold !important;
}

.btn-logout:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(211, 47, 47, 0.6) !important;
  background-color: #c62828 !important;
}

.btn-theme {
  box-shadow: 0 4px 12px rgba(200, 165, 1, 0.4) !important;
  transition: all 0.3s ease;
  font-weight: bold !important;
}

.btn-theme:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(200, 165, 1, 0.6) !important;
  background-color: #d4af37 !important;
}

.btn-card-action {
  box-shadow: 0 4px 12px rgba(200, 165, 1, 0.3) !important;
  transition: all 0.3s ease;
  font-weight: bold !important;
  padding: 12px 24px !important;
}

.btn-card-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(200, 165, 1, 0.5) !important;
  background-color: #d4af37 !important;
}

.btn-invia {
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.4) !important;
  transition: all 0.3s ease;
  font-weight: bold !important;
}

.btn-invia:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(46, 125, 50, 0.5) !important;
  background-color: #1b5e20 !important;
}

/* Miglioramento card header */
.card-header-primary {
  box-shadow: 0 4px 8px rgba(200, 165, 1, 0.3);
}

/* Modern Header Styles */
.modern-header-wrapper {
  margin-bottom: 30px;
  animation: fadeInUp 0.8s ease-out 0.3s backwards;
}

.modern-header-card {
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    #fefefe 50%,
    #f9f9f9 100%
  ) !important;
  border-radius: 20px !important;
  overflow: hidden;
  border: 1px solid rgba(200, 165, 1, 0.15);
  transition: all 0.3s ease;
  position: relative;
}

.modern-header-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(
    90deg,
    #c8a501 0%,
    #d4af37 50%,
    #c8a501 100%
  );
}

.modern-header-card:hover {
  box-shadow: 0 12px 40px rgba(200, 165, 1, 0.15) !important;
  transform: translateY(-2px);
}

/* Header Actions Row */
.header-actions-row {
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.action-buttons-group {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Action Buttons */
.action-btn {
  border-radius: 8px !important;
  height: 32px !important;
  min-width: 56px !important;
  font-size: 0.75rem !important;
  letter-spacing: 0.5px;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 6px rgba(200, 165, 1, 0.25) !important;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(200, 165, 1, 0.4) !important;
  background-color: #d4af37 !important;
}

.action-btn-icon {
  width: 36px !important;
  height: 36px !important;
  border-radius: 50% !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 6px rgba(200, 165, 1, 0.25) !important;
}

.action-btn-icon:hover {
  transform: translateY(-2px) rotate(5deg);
  box-shadow: 0 4px 12px rgba(200, 165, 1, 0.4) !important;
}

.action-btn-logout {
  box-shadow: 0 2px 6px rgba(211, 47, 47, 0.35) !important;
}

.action-btn-logout:hover {
  transform: translateY(-2px) rotate(-5deg);
  box-shadow: 0 4px 12px rgba(211, 47, 47, 0.5) !important;
  background-color: #c62828 !important;
}

.logo-container {
  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
  border-radius: 50%;
  padding: 15px;
  box-shadow: 0 4px 20px rgba(200, 165, 1, 0.15);
  transition: all 0.3s ease;
}

.logo-container:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 25px rgba(200, 165, 1, 0.25);
}

.logo-img {
  transition: transform 0.3s ease;
}

.title-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.header-title {
  font-family: "Poppins", "Segoe UI", "Roboto", -apple-system, BlinkMacSystemFont,
    sans-serif;
  font-size: 1.75rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.3;
  letter-spacing: -0.5px;
  margin: 0;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.chip-modern {
  border-radius: 12px !important;
  height: 32px !important;
  box-shadow: 0 2px 8px rgba(200, 165, 1, 0.25);
  transition: all 0.3s ease;
}

.chip-modern:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(200, 165, 1, 0.35);
}

.user-info-card {
  background: linear-gradient(135deg, #fafafa 0%, #ffffff 100%) !important;
  border: 2px solid rgba(200, 165, 1, 0.2) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease;
  height: 100%;
}

.user-info-card:hover {
  border-color: rgba(200, 165, 1, 0.4) !important;
  box-shadow: 0 4px 12px rgba(200, 165, 1, 0.1);
}

.info-item {
  transition: all 0.2s ease;
}

.info-label {
  display: flex;
  align-items: center;
  color: #7f8c8d;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  font-family: "Poppins", sans-serif;
}

/* Responsive adjustments for modern header */
@media (max-width: 960px) {
  .header-title {
    font-size: 1.5rem;
    text-align: center;
  }

  .title-section {
    align-items: center;
    text-align: center;
  }

  .modern-header-card .v-col {
    text-align: center;
  }

  .user-info-card {
    margin-top: 16px;
  }

  .action-buttons-group {
    justify-content: center;
    flex-wrap: wrap;
  }
}

@media (max-width: 600px) {
  .header-title {
    font-size: 1.25rem;
  }

  .modern-header-wrapper {
    margin-bottom: 20px;
  }

  .modern-header-card {
    border-radius: 16px !important;
  }

  .logo-container {
    padding: 10px;
  }

  .header-actions-row .pa-3 {
    padding: 8px !important;
  }

  .action-btn {
    min-width: 48px !important;
    height: 28px !important;
    font-size: 0.7rem !important;
  }

  .action-btn-icon {
    width: 32px !important;
    height: 32px !important;
  }

  .action-buttons-group {
    gap: 2px;
  }
}
</style>
